import type { ModelsTabletBookingOutput } from '@barbershop/api/customer'

export const extractCurrentBookingIds = (booking: ModelsTabletBookingOutput): number[] => {
    const appointmentIds = booking.appointments
        ?.map((appointment) => appointment.appointment_id)
        .filter(
            (appointmentId): appointmentId is number =>
                appointmentId != null && Number.isInteger(appointmentId) && appointmentId > 0
        )

    if (appointmentIds != null && appointmentIds.length > 0) {
        return appointmentIds
    }

    return booking.appointment_id != null &&
        Number.isInteger(booking.appointment_id) &&
        booking.appointment_id > 0
        ? [booking.appointment_id]
        : []
}
